import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import SubscriptionSuccess from '../components/SubscriptionSuccess';

const mapActionCreators = dispatch => ({
    dispatch: payload => dispatch(payload),
    push: payload => dispatch(push(payload)),
    navigateToList: () => dispatch(push('/subscriptions/list')),
});

const mapStateToProps = state => ({
    subscriptionDetails: state.subscriptions.get('newSubscription'),
    isFetching: state.subscriptions.get('isFetching'),
});

export default connect(
    mapStateToProps,
    mapActionCreators
)(SubscriptionSuccess);
